import { DrawableLine } from './Drawable/DrawableLine';

export class Door extends DrawableLine {}
